import { ActionCableLink } from "graphql-ruby-client";
import { cable } from "./actionCableConsumer";

const isActionCableConnectionOpen = () => {
  if (hasNoFailedReconnects()) return true;

  return cable.connection.isOpen();
};

const hasNoFailedReconnects = () => {
  return cable.connection.monitor.reconnectAttempts === 0;
};

const createCustomActionCableLink = () => {
  return new ActionCableLink({ cable });
};

export { isActionCableConnectionOpen, createCustomActionCableLink };
